import { Button, HStack, Text } from "@chakra-ui/react";
import { usePagination, useStats } from "react-instantsearch";
import {
  DRAFT_CAMPAIGNS_HITS_PER_PAGE,
  draftCampaignPaginationRange,
} from "./adsCampaignAlgoliaFilters";

export default function CampaignsTablePagination() {
  const { nbHits } = useStats();
  const { currentRefinement, isFirstPage, isLastPage, nbPages, refine } =
    usePagination();

  if (nbPages <= 1) {
    return null;
  }

  const page = currentRefinement + 1;
  const { start, end } = draftCampaignPaginationRange({
    page,
    pageSize: DRAFT_CAMPAIGNS_HITS_PER_PAGE,
    total: nbHits,
  });

  return (
    <HStack
      justify="flex-end"
      px={3}
      py={3}
      borderTopWidth="1px"
      borderColor="gray.200"
      gap={3}
    >
      <Button
        size="sm"
        variant="outline"
        fontSize="sm"
        fontWeight="400"
        color="gray.700"
        borderColor="gray.300"
        borderRadius="8px"
        isDisabled={isFirstPage}
        opacity={isFirstPage ? 0.5 : 1}
        onClick={() => refine(currentRefinement - 1)}
      >
        Previous
      </Button>
      <Text fontSize="sm" color="gray.600">
        Showing{" "}
        <Text as="span" fontWeight="600" color="gray.800">
          {start}-{end}
        </Text>{" "}
        of{" "}
        <Text as="span" fontWeight="600" color="gray.800">
          {nbHits}
        </Text>{" "}
        campaigns
      </Text>
      <Button
        size="sm"
        variant="outline"
        fontSize="sm"
        fontWeight="400"
        color="gray.700"
        borderColor="gray.300"
        borderRadius="8px"
        isDisabled={isLastPage}
        onClick={() => refine(currentRefinement + 1)}
      >
        Next
      </Button>
    </HStack>
  );
}
